import { i18n } from '@lingui/core';
import { messages as da } from '../../locales/da.mjs';
import { messages as en } from '../../locales/en.mjs';
import { messages as fi } from '../../locales/fi.mjs';
import { messages as nb } from '../../locales/nb.mjs';
import { messages as sv } from '../../locales/sv.mjs';

const translations = { da, en, fi, nb, sv };

// Load all translations and activate a default locale at import time,
// so any render that happens before connectedCallback has a locale available.
i18n.load(translations);
i18n.activate('en');

const activateI18n = (locale) => {
    i18n.activate(locale || 'en');
};

export default activateI18n;
